<template>
  <div class="performance-dashboard-view">
    <FleetKpiSection />

    <div class="dashboard-grid">
      <div class="left-column">
        <FoulingRateGraph />
        <FoulingDetailsSection />
      </div>

      <div class="middle-column">
        <VesselMovementMap />
        <PerformanceImpactSection />
      </div>

      <SupportiveEvidenceSection />
    </div>
  </div>
</template>

<script>
import FleetKpiSection from "./components/FleetKpiSection.vue";
import FoulingRateGraph from "./components/FoulingRateGraph.vue";
import FoulingDetailsSection from "./components/FoulingDetailsSection.vue";
import VesselMovementMap from "./components/VesselMovementMap.vue";
import PerformanceImpactSection from "./components/PerformanceImpactSection.vue";
import SupportiveEvidenceSection from "./components/SupportiveEvidenceSection.vue";

export default {
  name: "PerformanceDashboardView",

  components: {
    FleetKpiSection,
    FoulingRateGraph,
    FoulingDetailsSection,
    VesselMovementMap,
    PerformanceImpactSection,
    SupportiveEvidenceSection
  }
};
</script>

<style scoped>
.performance-dashboard-view {
  min-height: 100%;
  padding: 16px;
  background: #eef2f7;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: 320px 1fr 340px;
  gap: 16px;
  margin-top: 16px;
}

.left-column,
.middle-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

@media (max-width: 1200px) {
  .dashboard-grid {
    grid-template-columns: 1fr;
  }
}
</style>
